import moment, { type MomentInput } from 'moment'

const QUERY_DATE_FORMAT = 'YYYY-MM-DD HH:mm'

function toQueryDate(value: MomentInput): string | undefined {
  if (!value) return undefined

  return moment(value).format(QUERY_DATE_FORMAT)
}

/**
 * Query of planning/assets-for-period: the calendar may store moment objects, which the
 * query string would otherwise serialize as nested params and the API would reject.
 */
export function assetsForPeriodQuery({
  date_from,
  date_to
}: {
  date_from?: MomentInput
  date_to?: MomentInput
}): { date_from?: string; date_to?: string } {
  return {
    date_from: toQueryDate(date_from),
    date_to: toQueryDate(date_to)
  }
}
